export { BaseMedia } from '@/components/pages/conversations/SocialInbox/models/BaseMedia';
export { ImageMedia } from '@/components/pages/conversations/SocialInbox/models/ImageMedia';
export { VideoMedia } from '@/components/pages/conversations/SocialInbox/models/VideoMedia';
